import { useTranslation } from 'react-i18next';
import { ModulePlaceholderList } from '../../components/ModulePlaceholderList';

export default function AllEssRequests() {
  const { t } = useTranslation('panel');
  return (
    <ModulePlaceholderList
      title="Self-service requests"
      newPath="/panel/ess/new"
      newLabel="New request"
    />
  );
  void t;
}
